import * as e from "react";
import { styleSingleton as t } from "../../../react-style-singleton/dist/es2015/component.js";
import { focusHiddenMarker as r } from "./medium.js";
var n = t(), o = `
 [` + r + `] {
   pointer-events: none !important;
 }
`, s = function() {
  return e.createElement(n, { styles: o });
};
export {
  s as InteractivityDisabler
};
//# sourceMappingURL=InteractivityDisabler.js.map
